import {FC, useState} from "react";
import IService from "../../interfaces/Cookies/IService";
import {motion} from "framer-motion";
import Chevron from "../Svg/Chevron";
import Text from "../Base/Text";
import {useTranslation} from "react-i18next";

const Service:FC<IService> = ({name, url, description, cookies}) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    }

    return <div className="mx-4 px-3 py-2 text-xs rounded-xl border-1 border-disabled-300">
        <button
            className="flex w-full justify-between items-center gap-2 cursor-pointer"
            onClick={handleToggle}
        >
            <div className="flex items-center gap-1">
                <span className="font-semibold">{name}</span>
                {cookies.length > 0 ? <span className="block bg-accent-500 text-white px-1 rounded text-xs">{cookies.length}</span> : null}
            </div>

            <motion.div
                animate={{rotate: isOpen ? 180 : 0}}
                transition={{duration: 0.3}}
            >
                <Chevron className="w-3 h-3" />
            </motion.div>
        </button>

        {
            url ? <a href={url} target="_blank" className="inline-block pt-1 text-disabled-500">{t('cookies.link')}</a> : null
        }

        <motion.div
            initial={{height: 0, opacity: 0}}
            animate={{height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0}}
            transition={{duration: 0.3}}
            className="overflow-hidden"
        >
            <div className="border-t-1 border-t-disabled-300 mt-2 pt-2">
                { description ? <Text as="div"
                      className="text-disabled-500 mb-2"
                      text={description}
                /> : null }

                <div className="flex flex-col gap-1">
                    {
                        cookies.map((cookie, index) => {
                            return <div key={index} className="border-1 rounded-xl border-disabled-300 bg-disabled-300/30 text-disabled-500 py-2 px-3">
                                <div className="font-semibold mb-1">{cookie.name}</div>
                                <div className="text-[10px]">
                                    {
                                        cookie.description ? <div className="mb-1">{cookie.description}</div> : null
                                    }

                                    {
                                        cookie.duration ? <div><span className="font-semibold">{t('cookies.duration')}</span>: {cookie.duration}</div> : null
                                    }

                                    {
                                        cookie.duration ? <div><span className="font-semibold">{t('cookies.type')}</span>: {cookie.type}</div> : null
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </motion.div>
    </div>;
}

export default Service